import { makeStyles, TextField } from "@material-ui/core";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

interface CustomTextFieldProps {
  id: string;
  label: string;
  value?: string | number | null;
}

const useStyles = makeStyles(() => ({
  textField: {
    "& .MuiInput-underline.Mui-disabled:before": {
      borderBottomStyle: "solid",
    },
    borderColor: "#949494",
  },
}));

const CustomTextField: FC<CustomTextFieldProps> = ({ id, label, value }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <TextField
      className={classes.textField}
      id={id}
      label={t(label)}
      disabled
      fullWidth
      value={value}
      InputLabelProps={{
        shrink: !!value,
      }}
    />
  );
};


export default CustomTextField